import type { AssetLite } from "@/entities/asset";
import type { AssetTypeSelectOptionItem } from "@/modules/asset-type/asset-type-select";

export const shouldDisableAssetsBatchEditAssetType = (
  assets?: AssetLite[]
): boolean => {
  if (!assets?.length) return true;

  if (assets.length === 1) return false;

  return !assets.every((a) => a.asset_type_id === assets[0].asset_type_id);
};

export const getAssetsBatchEditAssetTypeInitialValue = (
  assets: AssetLite[]
): AssetTypeSelectOptionItem => {
  const firstAsset = assets[0];

  if (!firstAsset) return undefined;

  return {
    label: firstAsset.asset_type.name,
    value: firstAsset.asset_type_id,
  };
};
